export default {
  h1: {
    fontSize: '2rem',
    lineHeight: '1.1',
    fontWeight: '400',
    margin: {
      top: '1.25rem',
      right: '0',
      bottom: '0.625rem',
      left: '0',
    },
    responsive: {
      xl: {
        fontSize: '3.125rem',
        fontWeight: '400',
        lineHeight: '1.3',
        margin: {
          top: '0',
          right: '0',
          bottom: '0',
          left: '0',
        },
      },
      lg: {
        fontSize: '2.375rem',
        fontWeight: '400',
        lineHeight: '1.23684211',
        margin: {
          top: '0',
          right: '0',
          bottom: '0',
          left: '0',
        },
      },
      md: {
        fontSize: '2.0625rem',
        fontWeight: '400',
        lineHeight: '1.24242424',
        margin: {
          top: '0',
          right: '0',
          bottom: '0',
          left: '0',
        },
      },
      sm: {
        fontSize: '1.5625rem',
        fontWeight: '400',
        lineHeight: '1.2',
        margin: {
          top: '0',
          right: '0',
          bottom: '0',
          left: '0',
        },
      },
      xs: {
        fontSize: '1.5625rem',
        fontWeight: '400',
        lineHeight: '1.2',
        margin: {
          top: '0',
          right: '0',
          bottom: '0',
          left: '0',
        },
      },
    },
  },
  h2: {
    fontSize: '1.875rem',
    lineHeight: '1.1',
    fontWeight: '400',
    margin: {
      top: '1.25rem',
      right: '0',
      bottom: '0.625rem',
      left: '0',
    },
    responsive: {
      lg: {
        fontSize: '1rem',
        fontWeight: '400',
        lineHeight: '1.625',
        margin: {
          top: '1.875rem',
          right: '0',
          bottom: '-0.625rem',
          left: '0',
        },
      },
      md: {
        fontSize: '1rem',
        fontWeight: '400',
        lineHeight: '1.625',
        margin: {
          top: '1.875rem',
          right: '0',
          bottom: '-0.625rem',
          left: '0',
        },
      },
      sm: {
        fontSize: '0.875rem',
        fontWeight: '400',
        lineHeight: '1.64285714',
        margin: {
          top: '1.875rem',
          right: '0',
          bottom: '-0.625rem',
          left: '0',
        },
      },
      xs: {
        fontSize: '0.875rem',
        fontWeight: '400',
        lineHeight: '1.64285714',
        margin: {
          top: '1.875rem',
          right: '0',
          bottom: '-0.625rem',
          left: '0',
        },
      },
    },
  },
  h3: {
    fontSize: '1.5rem',
    lineHeight: '1.1',
    fontWeight: '500',
    margin: {
      top: '1.25rem',
      right: '0',
      bottom: '0.625rem',
      left: '0',
    },
    responsive: {
      lg: {
        fontSize: '1.5rem',
        fontWeight: '400',
        lineHeight: '1.1',
        margin: {
          top: '1.25rem',
          right: '0',
          bottom: '0.625rem',
          left: '0',
        },
      },
      md: {
        fontSize: '1.5rem',
        fontWeight: '400',
        lineHeight: '1.1',
        margin: {
          top: '1.25rem',
          right: '0',
          bottom: '0.625rem',
          left: '0',
        },
      },
      sm: {
        fontSize: '1.5rem',
        fontWeight: '400',
        lineHeight: '1.1',
        margin: {
          top: '1.25rem',
          right: '0',
          bottom: '0.625rem',
          left: '0',
        },
      },
      xs: {
        fontSize: '1.5rem',
        fontWeight: '400',
        lineHeight: '1.1',
        margin: {
          top: '1.25rem',
          right: '0',
          bottom: '0.625rem',
          left: '0',
        },
      },
    },
  },
  h4: {
    fontSize: '1.125rem',
    lineHeight: '1.1',
    fontWeight: '500',
    margin: {
      top: '0.625rem',
      right: '0',
      bottom: '0.625rem',
      left: '0',
    },
    responsive: {
      lg: {
        fontSize: '1.125rem',
        fontWeight: '400',
        lineHeight: '1.1',
        margin: {
          top: '0.625rem',
          right: '0',
          bottom: '0.625rem',
          left: '0',
        },
      },
      md: {
        fontSize: '1.125rem',
        fontWeight: '400',
        lineHeight: '1.1',
        margin: {
          top: '0.625rem',
          right: '0',
          bottom: '0.625rem',
          left: '0',
        },
      },
      sm: {
        fontSize: '1.125rem',
        fontWeight: '400',
        lineHeight: '1.1',
        margin: {
          top: '0.625rem',
          right: '0',
          bottom: '0.625rem',
          left: '0',
        },
      },
      xs: {
        fontSize: '1.125rem',
        fontWeight: '400',
        lineHeight: '1.1',
        margin: {
          top: '0.625rem',
          right: '0',
          bottom: '0.625rem',
          left: '0',
        },
      },
    },
  },
  h5: {
    fontSize: '0.875rem',
    lineHeight: '1.1',
    fontWeight: '500',
    margin: {
      top: '0.625rem',
      right: '0',
      bottom: '0.625rem',
      left: '0',
    },
    responsive: {
      lg: {
        fontSize: '0.875rem',
        lineHeight: '1.1',
        fontWeight: '500',
        margin: {
          top: '0.625rem',
          right: '0',
          bottom: '0.625rem',
          left: '0',
        },
      },
      md: {
        fontSize: '0.875rem',
        lineHeight: '1.1',
        fontWeight: '500',
        margin: {
          top: '0.625rem',
          right: '0',
          bottom: '0.625rem',
          left: '0',
        },
      },
      sm: {
        fontSize: '0.875rem',
        lineHeight: '1.1',
        fontWeight: '500',
        margin: {
          top: '0.625rem',
          right: '0',
          bottom: '0.625rem',
          left: '0',
        },
      },
      xs: {
        fontSize: '0.875rem',
        lineHeight: '1.1',
        fontWeight: '500',
        margin: {
          top: '0.625rem',
          right: '0',
          bottom: '0.625rem',
          left: '0',
        },
      },
    },
  },
  h6: {
    fontSize: '0.75rem',
    lineHeight: '1.1',
    fontWeight: '500',
    margin: {
      top: '0.625rem',
      right: '0',
      bottom: '0.625rem',
      left: '0',
    },
    responsive: {
      lg: {
        fontSize: '0.75rem',
        lineHeight: '1.1',
        fontWeight: '500',
        margin: {
          top: '0.625rem',
          right: '0',
          bottom: '0.625rem',
          left: '0',
        },
      },
      md: {
        fontSize: '0.75rem',
        lineHeight: '1.1',
        fontWeight: '500',
        margin: {
          top: '0.625rem',
          right: '0',
          bottom: '0.625rem',
          left: '0',
        },
      },
      sm: {
        fontSize: '0.75rem',
        lineHeight: '1.1',
        fontWeight: '500',
        margin: {
          top: '0.625rem',
          right: '0',
          bottom: '0.625rem',
          left: '0',
        },
      },
      xs: {
        fontSize: '0.75rem',
        lineHeight: '1.1',
        fontWeight: '500',
        margin: {
          top: '0.625rem',
          right: '0',
          bottom: '0.625rem',
          left: '0',
        },
      },
    },
  },
};
